import { useStore } from '../../store/reducers';

export function useIsAdmin() {
  const isAdmin = useStore((s) => s.users.getter.isAdmin());

  return isAdmin;
}
